import BaseReducer from "shared/types/baseReducer";
import { Action, PaymentActionType, PaymentDispatchInterface, PaymentState } from "./types";

export default class Reducer extends BaseReducer<PaymentActionType> implements PaymentDispatchInterface {
  static getInitialState(): PaymentState {
    return {
      isPayButtonDisabled: true,
      paymentError: undefined,
      displayLoader: false
    };
  }

  static reducer(state: PaymentState, action: PaymentActionType): PaymentState {
    switch (action.type) {
      case Action.PAY_BUTTON_DISABLE:
        return { ...state, isPayButtonDisabled: action.payload };
      case Action.PAYMENT_ERROR:
        return { ...state, paymentError: action.payload };
      case Action.DISPLAY_LOADER:
        return { ...state, displayLoader: action.payload };
    }
  }

  public setIsPayButtonDisabled(payload: boolean) {
    return this.dispatch({ type: Action.PAY_BUTTON_DISABLE, payload });
  }

  public setPaymentError(payload: string) {
    return this.dispatch({ type: Action.PAYMENT_ERROR, payload });
  }

  public setDisplayLoader(payload: boolean) {
    return this.dispatch({ type: Action.DISPLAY_LOADER, payload });
  }
}
